import { render, staticRenderFns } from "./All.vue?vue&type=template&id=3838fa5c&scoped=true&"
import script from "./All.vue?vue&type=script&lang=js&"
export * from "./All.vue?vue&type=script&lang=js&"
import style0 from "./All.vue?vue&type=style&index=0&id=3838fa5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3838fa5c",
  null
  
)

export default component.exports